export const addressFields = [
  { id: 'street', label: 'Street Address', col: 12, type: 'text' },
  { id: 'city', label: 'City', col: 6, type: 'text' },
  { id: 'region', label: 'Region/County', col: 6, type: 'text' },
  { id: 'country', label: 'Country', col: 6, type: 'text' },
  { id: 'zip', label: 'Zip/Post Code', col: 6, type: 'text' },
];